import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { PDFDialogComponent } from 'src/app/signup-organization/pdf-dialog/pdf-dialog.component';

@Component({
  selector: 'app-employer-settings',
  templateUrl: './employer-settings.component.html',
  styleUrls: ['./employer-settings.component.scss']
})
export class EmployerSettingsComponent implements OnInit {

  constructor(
        public dialog: MatDialog,
    
  ) { }

  ngOnInit() {
  }
  openPdfDialog() {
    let data = {
      title: 'Employer Template Instructions',
      filename: 'EMPLOYER_CENSUS_TEMPLATE_INSTRUCTIONS.pdf',
    }
  
  
    this.dialog.open(PDFDialogComponent, { panelClass:'pricing-pdf-modal', id: 'subscription_dialog', data: { ...data, isBack: false, } });
  }
  downloadFile() {
    const fileUrl = 'assets/pdf/CensusTemplate.xlsx'; // Correct path to your assets folder
    const anchor = document.createElement('a');
  
    // Check if the file exists before attempting to download
    fetch(fileUrl, { method: 'HEAD' })
      .then((response) => {
        if (response.ok) {
          anchor.href = fileUrl;
          anchor.download = 'CensusTemplate.xlsx'; // The file name for download
          anchor.click();
          anchor.remove(); // Clean up the created element
        } else {
          console.error('File not found or server error');
          alert('There was an issue with the file. Please check your internet connection or try again later.');
        }
      })
      .catch((error) => {
        console.error('Network error:', error);
        alert('Network error. Please check your internet connection.');
      });
  }
  
}
